import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  countries: [],
  isProcessing: false
}

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCountries: (state, action) => {
      state.countries = action.payload
    },
    setIsProcessing: (state, action) => {
      state.isProcessing = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { setCountries, setIsProcessing } = commonSlice.actions

export default commonSlice.reducer